export const formatDateMDDYYYY = (date) => {
    date = new Date(date);
    const formattedDate = date.toLocaleDateString("en-US", {
        month: "long",
        day: "numeric",
        year: "numeric",
    });
    return formattedDate;
};

export const getLastWeekRange = () => {
    const today = new Date();
    const dayOfWeek = today.getDay(); // Get the current day of the week (0-6, Sun-Sat)

    // Calculate the last Sunday (start of the last week)
    const lastSunday = new Date(today);
    lastSunday.setDate(today.getDate() - dayOfWeek - 7);

    // Calculate the last Saturday (end of the last week)
    const lastSaturday = new Date(today);
    lastSaturday.setDate(today.getDate() - dayOfWeek - 1);

    return {
        firstDay: lastSunday,
        lastDay: lastSaturday,
    };
};

export const getLastMonthRange = () => {
    const today = new Date();

    // Set the date to the first day of the current month and subtract 1 day to go to the last day of the previous month
    const lastDayOfLastMonth = new Date(
        today.getFullYear(),
        today.getMonth(),
        0
    );

    // Set the date to the first day of the previous month
    const firstDayOfLastMonth = new Date(
        today.getFullYear(),
        today.getMonth() - 1,
        1
    );

    return {
        firstDay: firstDayOfLastMonth,
        lastDay: lastDayOfLastMonth,
    };
}

export const currentYear = new Date().getFullYear();
